import { render } from "./PathwaysIndex.vue?vue&type=template&id=5c10ed2c"
import script from "./PathwaysIndex.vue?vue&type=script&lang=js"
export * from "./PathwaysIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__